var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRenovacaonovo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "228px",
    height: "264px",
    viewBox: "0 0 228 264",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BD412A00-9368-4233-8452-00C26DDA4911") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9999892%",
    y1: "100.000008%",
    x2: "49.9999892%",
    y2: "5.85041999e-06%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "53.514%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "53.514%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05.1-nova-assinatura",
    transform: "translate(-560.000000, -248.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ilustra+bg",
    transform: "translate(40.000000, 248.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-ilustra-renovacao",
    transform: "translate(520.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.372035,183.787486 C149.06228,168.035234 125.1335,156.425295 106.462331,153.42852 L106.462331,145.861832 C106.80744,145.73238 107.150631,145.599042 107.491906,145.461819 C107.3939,143.949672 107.092182,142.457962 106.595041,141.027672 C114.570554,137.762793 121.457468,132.277794 126.449619,125.214732 C137.091504,114.000398 142.136895,98.547705 140.179958,83.1623501 C138.223021,67.7769951 129.472933,54.1035145 116.367795,45.9518515 C120.00698,43.6413537 121.774818,39.2491312 120.760025,35.0392864 C119.745231,30.8294417 116.174422,27.7420812 111.888277,27.3686773 C115.400073,19.0184364 112.794254,9.33285886 105.576801,3.90953136 C98.3593482,-1.51379614 88.3968488,-1.27228556 81.4469307,4.49448688 C87.5065981,1.24779465 94.8133764,1.43936078 100.697051,4.99917866 C106.580725,8.55899654 110.179095,14.9654065 110.177161,21.8772275 C110.177161,22.0500258 110.167008,22.2202974 110.162619,22.3920396 C109.929199,14.6042291 105.156533,7.68775084 97.9896392,4.75113615 C90.8227458,1.81452146 82.6102136,3.41035049 77.0430704,8.8213963 C71.4759273,14.2324421 69.6017375,22.4405131 72.262834,29.7565865 C69.2343811,30.4158081 66.6955646,32.4816281 65.4197072,35.3247982 C64.1438498,38.1679683 64.282019,41.4518441 65.7921284,44.176158 C51.4440874,51.7675538 41.5273927,65.7674247 39.0709372,81.8997382 C36.6144817,98.0320517 41.9100413,114.380623 53.3401736,125.952048 C58.0892382,132.395267 64.4412844,137.463894 71.7559668,140.646966 L71.7559668,153.259408 C52.8870699,155.973886 28.0386483,167.799429 23.6968455,183.93987 C19.9132219,198.005318 15.8743825,213.452246 13.8648649,222.521452 C31.0895864,234.708744 67.2325093,241.864865 89.8834083,241.864865 C111.404392,241.864865 146.579694,235.405936 163.297297,224.30862 C161.486517,214.34354 157.320263,198.218363 153.372035,183.787486 Z M118.867567,38.2851554 C118.867567,38.4644132 118.860207,38.6418568 118.850839,38.8187498 C118.590627,34.2383731 115.22327,30.4459939 110.731891,29.6750432 C110.921209,29.3522134 111.101733,29.0237772 111.273464,28.6897346 C115.716429,29.7149497 118.86661,33.695317 118.867567,38.2851554 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.856549,237.243243 C110.933808,237.243243 145.383856,230.996257 161.756757,220.26309 C159.98331,210.625036 155.902952,195.028962 152.036145,181.071652 C147.111523,163.296194 116.030309,150.972973 97.489061,150.972973 L79.6220612,150.972973 C61.0233844,150.972973 29.897325,163.367499 25.0346908,181.219041 C21.3290863,194.822929 17.3735163,209.762974 15.4054054,218.534574 C32.2749947,230.321948 67.6726712,237.243243 89.856549,237.243243 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6A58",
    cx: 88.5810811,
    cy: 90.1216216,
    r: 50.0675676
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7679216,124.783784 L100.853713,124.783784 C103.009305,124.783784 104.756757,126.574561 104.756757,128.783596 L104.756757,156.117265 C104.756757,160.472989 103.068314,164.650313 100.062867,167.730275 C97.0574193,170.810236 92.9811579,172.540541 88.7308135,172.540541 L86.8908081,172.540541 C82.6404637,172.540541 78.5642023,170.810236 75.558755,167.730275 C72.5533076,164.650313 70.8648649,160.472989 70.8648649,156.117265 L70.8648649,128.783596 C70.8648649,127.722778 71.276079,126.705408 72.0080445,125.955297 C72.74001,125.205186 73.7327678,124.783784 74.7679216,124.783784 Z",
    id: "Path",
    fill: "#FDA57D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3090681,147.891892 C93.9436789,147.895121 99.5267842,146.815121 104.756757,144.710211 C104.200643,136.104725 97.0877643,129.409288 88.4977401,129.405405 L87.1034388,129.405405 C78.6668675,129.407296 71.6243895,135.868466 70.8648649,144.303597 C76.3762685,146.677381 82.3118506,147.898329 88.3090681,147.891892 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDA57D",
    cx: 88.5810811,
    cy: 99.3648649,
    r: 43.9054054
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6A58",
    cx: 73.9459459,
    cy: 41.5945946,
    r: 9.24324324
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6A58",
    cx: 109.378378,
    cy: 41.5945946,
    r: 9.24324324
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF6A58",
    cx: 88.5810811,
    cy: 25.4189189,
    r: 19.2567568
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.274288,29.2702703 C108.308355,29.2673969 106.386591,29.8318556 104.756757,30.8908855 C109.450163,29.2754398 114.657781,31.27962 116.903766,35.565728 C119.149751,39.8518359 117.731113,45.0783263 113.594727,47.7567568 C118.125444,46.2025291 120.836534,41.7316013 120.016551,37.166363 C119.196569,32.6011247 115.083694,29.2676498 110.274288,29.2702703 L110.274288,29.2702703 Z",
    id: "Path",
    fill: "#F55F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6838586,4.62162162 C88.0940155,4.61472216 83.645906,6.20018143 80.1081081,9.10407433 C89.073162,4.37085162 100.191092,7.15019751 105.831005,15.5344822 C111.470917,23.9187668 109.799403,35.1824484 101.963722,41.5945946 C109.980688,37.3641021 114.06628,28.255385 111.870623,19.5074259 C109.674966,10.7594667 101.762369,4.62059144 92.6838519,4.62162162 L92.6838586,4.62162162 Z",
    id: "Path",
    fill: "#FF6A58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,60.3199924 C57,60.3199924 62.2106475,94.868892 127.864865,76.0240353 L95.558854,47.7567568 L57,60.3199924 Z",
    id: "Path",
    fill: "#FF6A58"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.7,
    transform: "translate(0.000000, 175.621622)",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.336826351,
    y: 0.0389309128,
    width: 176.235732,
    height: 101.10094,
    rx: 14.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.0810811,177.162162 L157.540541,177.162162 C165.824812,177.162162 172.540541,183.877891 172.540541,192.162162 L172.540541,277.297297 L172.540541,277.297297 L3.08108108,277.297297 L3.08108108,192.162162 C3.08108108,183.877891 9.79680983,177.162162 18.0810811,177.162162 Z",
    id: "Rectangle",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(186.405405, 188.891892)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1216216,32.3513514 C28.4421279,32.3513514 24.6486486,36.1448306 24.6486486,40.8243243 C24.6486486,45.5038181 28.4421279,49.2972973 33.1216216,49.2972973 C37.8011154,49.2972973 41.5945946,45.5038181 41.5945946,40.8243243 C41.5945946,38.5771522 40.7019089,36.4220183 39.1129183,34.8330277 C37.5239276,33.244037 35.3687938,32.3513514 33.1216216,32.3513514 L33.1216216,32.3513514 Z M33.1216216,46.0384852 C31.0126951,46.0384852 29.1114256,44.7681032 28.3043725,42.8197099 C27.4973194,40.8713167 27.9434182,38.6286177 29.4346535,37.1373805 C30.9258888,35.6461433 33.1685872,35.2000417 35.1169815,36.0070924 C37.0653758,36.814143 38.3357629,38.7154109 38.3357629,40.8243374 C38.3357629,43.7040277 36.0013119,46.0384852 33.1216216,46.0384852 Z",
    id: "Shape",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1216216,32.3513514 C28.4421279,32.3513514 24.6486486,36.1448306 24.6486486,40.8243243 C24.6486486,45.5038181 28.4421279,49.2972973 33.1216216,49.2972973 C37.8011154,49.2972973 41.5945946,45.5038181 41.5945946,40.8243243 C41.5945946,38.5771522 40.7019089,36.4220183 39.1129183,34.8330277 C37.5239276,33.244037 35.3687938,32.3513514 33.1216216,32.3513514 L33.1216216,32.3513514 Z M33.1216216,46.0384852 C31.0126951,46.0384852 29.1114256,44.7681032 28.3043725,42.8197099 C27.4973194,40.8713167 27.9434182,38.6286177 29.4346535,37.1373805 C30.9258888,35.6461433 33.1685872,35.2000417 35.1169815,36.0070924 C37.0653758,36.814143 38.3357629,38.7154109 38.3357629,40.8243374 C38.3357629,43.7040277 36.0013119,46.0384852 33.1216216,46.0384852 Z",
    id: "Shape",
    fill: "#1717CE",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,24.6486486 L32.3513514,24.6486486 L32.3513514,55.1505237 C32.3513514,58.7244124 29.5120866,61.6216216 26.0096759,61.6216216 L6.3416754,61.6216216 C2.83926479,61.6216216 0,58.7244124 0,55.1505237 L0,24.6486486 Z",
    id: "Path",
    fill: "#1717CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1369659,24.6486486 L26.1369659,55.1843702 C26.1369659,58.739566 23.4014531,61.6216216 20.027027,61.6216216 L23.1603314,61.6216216 C26.5347575,61.6216216 29.2702703,58.739566 29.2702703,55.1843702 L29.2702703,24.6486486 L26.1369659,24.6486486 Z",
    id: "Path",
    fill: "#000000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64143355,0.808672563 C7.10680141,0.826095473 6.60734279,1.08561306 6.27811082,1.51705202 C5.87315462,2.26833913 6.6069779,3.11542048 7.27664153,3.63162706 C8.51380493,4.5853582 9.81777208,5.52218037 10.6587247,6.85335267 C11.4996772,8.18452498 11.7638447,10.0421877 10.844581,11.3179517 C9.6442611,12.9837528 6.78055716,13.3420872 6.5034113,15.3923039 C6.32548729,16.7085364 7.43737893,17.8316558 8.56401791,18.4921223 C11.3448177,20.1222951 14.9296582,20.5571963 16.9439001,23.1081081 C17.7771438,21.3546179 19.6408833,20.3410066 21.4986269,19.9081571 C23.3563706,19.4753076 25.2865538,19.5076201 27.1701054,19.2139807 C27.7940873,19.2017995 28.3751425,18.886382 28.7349566,18.3645237 C29.2614791,17.2709727 27.7608434,15.9594153 28.2787571,14.8615767 C28.6729631,14.0259988 29.8309775,14.0908907 30.6766224,13.7562619 C32.0535628,13.2114078 32.6213667,11.3978533 32.230562,9.94093712 C31.8397573,8.48402096 30.7358476,7.34542807 29.5750402,6.41193434 C26.4466288,3.89616173 22.6849132,2.41665157 18.8801721,1.35247215 C17.1106146,0.857525661 15.0333489,0.0813641939 13.1953677,0.00632822254 C11.4210868,-0.0661288439 9.39755337,0.501217545 7.64143355,0.808672563 Z",
    id: "Path",
    fill: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 87.0405405,
    cy: 227.22973,
    r: 5.39189189
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenovacaonovo);
export default __webpack_public_path__ + "static/media/renovacaonovo.f41e19ce53ee1bbd5348d6ba084b2087.svg";
export { ForwardRef as ReactComponent };